import { gql, useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';

import { GET_PAYROLL_ACCOUNTING_SETTINGS } from './get-payroll-accounting-settings.hook';
import { GET_PAYROLL_ACCOUNTING_ACTIVE_SETTINGS } from './get-payroll-accounting-active-settings.hook';

export const CREATE_PAYROLL_ACCOUNTING_SETTINGS = gql`
  mutation createPayrollAccountingSetting($payload: CreatePayrollAccountingSettingInput!) {
    createPayrollAccountingSetting(payload: $payload) {
      _id
    }
  }
`;

export const useCreatePayrollAccountingSetting = ({ onSuccess }: { onSuccess?: () => void }) => {
  const { t } = useTranslation('payrollAccounting');
  const [createPayrollAccountingSetting] = useMutation(CREATE_PAYROLL_ACCOUNTING_SETTINGS, {
    onCompleted: data => {
      if (data?.createPayrollAccountingSetting?._id) {
        showNotification({
          isIcon: false,
          type: NOTIFICATION_TYPE.success,
          message: t('notifications.created'),
        });
      }
      if (onSuccess) {
        onSuccess();
      }
    },
    refetchQueries: [GET_PAYROLL_ACCOUNTING_SETTINGS, GET_PAYROLL_ACCOUNTING_ACTIVE_SETTINGS],
  });
  return createPayrollAccountingSetting;
};
